/**
 * The enrichment domain's isomorphic face (ADR 0014, Rule D).
 *
 * Third-party catalogue metadata: TMDB, Open Library, Discogs, and the AI fallback woven through
 * each, behind one normalised result. Every file outside `src/enrichment/` reaches this domain
 * through this module or through `@/enrichment/server`.
 *
 * **Explicit named exports, never `export *`.** A face is an interface, not a bag.
 *
 * **Two faces, for the reason `capture/` has two (#402).** The provider modules read `process.env`
 * credentials and are what the three lookup routes delegate to; publishing them here would put
 * them in the client graph of every component importing `@/enrichment`, and Turbopack does not
 * shake a server-only re-export out of a client graph. `server/index.ts` holds them.
 *
 * **The seam here is `providers/`, and it survived deleting the HTTP hop.** Until #407 the four
 * adapters lived inside three Next.js route modules and `enrich.ts` reached them with a
 * cookie-less `fetch` at the app's own origin — every call met the routes' `getUser()` guard and
 * came back 401, so enrichment silently returned nothing (#78). The transport was never the seam.
 *
 * @see CONTEXT.md for what enrichment means, and ADR 0009 for the two-adapter test
 */

// ============================================================================
// The enricher
// ============================================================================

export { enrichMedia, enrichFromAnalysis } from './enrich'
export type {
  AIFallbackInfo,
  AlternativeResult,
  EnrichedMediaResult,
  EnrichRequest,
  MediaType,
} from './enrich'

// ============================================================================
// The hook the capture form takes
// ============================================================================

export { useMediaEnrichment } from './use-media-enrichment'
